//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Days of the week */
export const DayOfWeek = {
    /** Sunday */
    Sunday: 0,

    /** Monday */
    Monday: 1,

    /** Tuesday */
    Tuesday: 2,

    /** Wednesday */
    Wednesday: 3,

    /** Thursday */
    Thursday: 4,

    /** Friday */
    Friday: 5,

    /** Saturday */
    Saturday: 6
} as const;

/** Days of the week */
export const DayOfWeekDescription: Record<number, string> = {
    0: "Sunday",

    1: "Monday",

    2: "Tuesday",

    3: "Wednesday",

    4: "Thursday",

    5: "Friday",

    6: "Saturday"
};

/** Days of the week */
export type DayOfWeek = typeof DayOfWeek[keyof typeof DayOfWeek];
